/**
 * Lingua dell'interfaccia (it | en). All'inizio: la scelta salvata nel browser, altrimenti quella del browser (italiano
 * se è italiano, inglese per tutto il resto). Dopo l'accesso vince la preferenza dell'utente sul server (ui-prefs `lang`).
 */
import type { Lingua } from "@qa/shared";

export const CHIAVE_LINGUA = "lang";
const STORAGE = "qa.lang";

export const isLingua = (v: unknown): v is Lingua => v === "it" || v === "en";

export function linguaIniziale(): Lingua {
  try {
    const s = localStorage.getItem(STORAGE);
    if (isLingua(s)) return s;
  } catch {
    /* storage non disponibile */
  }
  const nav = typeof navigator !== "undefined" ? (navigator.languages?.[0] ?? navigator.language ?? "") : "";
  return nav.toLowerCase().startsWith("it") ? "it" : "en";
}

export function ricordaNelBrowser(l: Lingua) {
  try {
    localStorage.setItem(STORAGE, l);
  } catch {
    /* storage non disponibile */
  }
}

/** Locale BCP 47 per Intl: inglese britannico (date gg/mm/aaaa). */
export const localeDi = (l: Lingua) => (l === "it" ? "it-IT" : "en-GB");
